
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/multilevel/multieco/[slug]",
      function () {
        return require("private-next-pages/alu/multilevel/multieco/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/multilevel/multieco/[slug]"])
      });
    }
  